<template>
  <div class="accordion accordion-flush ts-panel-accordion ts-advanced-accordion search-panel-group">
    <div class="accordion-item">
      <div class="accordion-header">
        <button
          class="accordion-button search-panel-label"
          :class="{ collapsed: !open }"
          type="button"
          :aria-expanded="String(open)"
          :aria-controls="bodyId"
          @click="open = !open"
        >
          {{ title }}
        </button>
      </div>
      <div v-show="open" :id="bodyId" class="accordion-collapse">
        <div class="accordion-body">
          <div class="d-flex flex-column gap-2">
            <slot />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator';

let uid = 0;

// Collapsible group of filter options (accordion of the design's "Erweiterte Suche")
@Component
export default class TsFilterGroup extends Vue {
  @Prop({ required: true }) readonly title!: string;

  @Prop({ type: Boolean, default: true }) readonly initiallyOpen!: boolean;

  open = true;

  // Props are not available yet while vue-class-component collects data
  created() {
    this.open = this.initiallyOpen;
  }

  bodyId = `ts-filter-group-${uid += 1}`;
}
</script>
